module.exports = __webpack_public_path__ + "img/santander.cfdb3633.svg";